import dayjs from 'dayjs'
/**
 *
 * @param {string} isoDate - date string in the format: yyyy-mm-dd)
 * @returns date formatted: day month(3 letter) year
 */
export function formatIsoDate(isoDate) {
  if (!isoDate) {
    return ''
  }

  const date = dayjs(isoDate)

  return date.isValid() ? date.format('DD MMM YYYY') : String(isoDate)
}

export function formatNumberMaxDecimalPlaces(value, decimalPlaces = 2) {
  const numberValue = Number(value)

  if (!Number.isFinite(numberValue)) {
    return String(value)
  }

  const multiplier = 10 ** decimalPlaces
  return String(Math.round((numberValue + Number.EPSILON) * multiplier) / multiplier)
}

export function formatNumberTextMaxDecimalPlaces(value, decimalPlaces = 2) {
  if (value === null || value === undefined) {
    return ''
  }

  return String(value).replace(
    /-?\d+\.\d{3,}/g,
    numberText => formatNumberMaxDecimalPlaces(numberText, decimalPlaces),
  )
}
